// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1xoFd";
var _4 = "header-3R3T1";
var _5 = "title-1DW7m";
var _6 = "description-1b9Wp";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "header", _5 as "title", _6 as "description" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "header": _4, "title": _5, "description": _6 }
